import { render, staticRenderFns } from "./TourGuideHuella.vue?vue&type=template&id=93670c1e&scoped=true"
import script from "./TourGuideHuella.vue?vue&type=script&lang=js"
export * from "./TourGuideHuella.vue?vue&type=script&lang=js"
import style0 from "./TourGuideHuella.vue?vue&type=style&index=0&id=93670c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93670c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCardText,VCardTitle,VSpacer})
